import {Modal} from 'react-bootstrap'
import {createPortal} from 'react-dom'
import {useIntl} from 'react-intl'
import {ID, KTSVG} from '../../../../../../_metronic/helpers'
import { EditProjectTeamsModalForm } from './EditProjectTeamsModalForm'
import { Team } from '../../../../../../_metronic/partials/modals/team/core/_models'

type Props = {
    show: boolean
    handleClose: () => void
    project_id: ID
    teams?: Team[]
  }
  
const modalsRoot = document.getElementById('root-modals') || document.body

const EditProjectTeamsModal = ({show, handleClose, project_id, teams}: Props) => {
    const intl = useIntl()

    return createPortal(
        //@ts-ignore
        <Modal
          id='kt_modal_edit_project_teams'
          tabIndex={-1}
          aria-hidden='true'
          dialogClassName='modal-dialog modal-dialog-centered mw-500px'
          show={show}
          onHide={handleClose}
          data-backdrop='static'
        >
            <div className='modal-header'>
                <h2>{intl.formatMessage({id: 'PROJECT.ACTIONS.VISIBILITY_SETTINGS'})}</h2>
                <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={handleClose}>
                <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
                </div>
            </div>
            <div className='modal-body px-lg-10'>
                <EditProjectTeamsModalForm project_id={project_id} handleClose={handleClose} teams={teams} />
            </div>
        </Modal>,
        modalsRoot
    )
}

export {EditProjectTeamsModal}